// Core
import { printingUrl, producerReturnUrl } from './apiEndpoints';
import { GUIDType } from '../interfaces/types';

import ApiBase from './ApiBase';
import { IProducerReturn, IProducerReturnSummary } from '../interfaces/IProducerReturn';

class ProducerReturnApi extends ApiBase {
    getProducerReturn(id: GUIDType) {
        return this.get<IProducerReturn>(
            `${producerReturnUrl}/${id}`
        );
    }

    getProducerReturnByAnnouncement(announcementId: GUIDType) {
        return this.get<IProducerReturn>(
            `${producerReturnUrl}/getByAnnouncement/${announcementId}`
        );
    }

    getProducerReturnListByAnnouncements(announcementIds: GUIDType[]) {
        let payload = {
            AnnouncementIds: announcementIds
        };

        return this.postList<IProducerReturnSummary>(
            `${producerReturnUrl}/getListByAnnouncements`,
            payload
        );
    }

    getProducerReturnPdf(Id: string) {
        return this.get<Blob>(`${printingUrl}/printProducerReturn?Id=${Id}`, {
            responseType: 'blob',
            incompatibleResult: true,
        }).then((response) => {
            if (response) {
                const blob = new Blob([response.Entity], { type: 'application/pdf' });
                return blob;
            }
        });
    }

    createProducerReturn(payload: IProducerReturn) {
        return this.post<IProducerReturn>(
            `${producerReturnUrl}`,
            payload
        );
    }

    updateProducerReturn(payload: IProducerReturn) {
        return this.put<IProducerReturn>(
            `${producerReturnUrl}`,
            payload
        );
    }

    deleteProducerReturn(id: GUIDType) {
        return this.delete<void>(
            `${producerReturnUrl}/${id}`
        );
    }
}

export default new ProducerReturnApi();
